function l(e) {
  return e != null && typeof e == "object" && e["@@functional/placeholder"] === !0;
}
export {
  l as default
};
